import { Component, OnInit, OnDestroy } from '@angular/core';
import { SmartintegVisualizacaoService } from '../../../../services/smartinteg-visualizacao.service';
import { DashboardResponse } from '../../../../types/smartinteg';
import { Subject, takeUntil, timer } from 'rxjs';

@Component({
  selector: 'app-dashboard-monitoramento',
  templateUrl: './dashboard-monitoramento.component.html',
  styleUrls: ['./dashboard-monitoramento.component.css']
})
export class DashboardMonitoramentoComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  dashboardData?: DashboardResponse;
  loading: boolean = true;
  periodo: string = '24h';
  
  chartData: any;
  chartOptions: any;
  
  pieData: any;
  pieOptions: any;

  constructor(private visualizacaoService: SmartintegVisualizacaoService) {}

  ngOnInit(): void {
    this.carregarDados();
    
    // Auto-refresh a cada 30 segundos
    timer(30000, 30000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.carregarDados(false));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  carregarDados(showLoading = true): void {
    if (showLoading) this.loading = true;
    
    this.visualizacaoService.getDashboard(this.periodo)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.dashboardData = data;
          this.prepararGraficos();
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          console.error('Erro ao carregar dashboard:', err);
        }
      });
  }

  alterarPeriodo(p: string): void {
    this.periodo = p;
    this.carregarDados();
  }

  prepararGraficos(): void {
    if (!this.dashboardData) return;

    const volume = this.dashboardData.graficos.volumePorPeriodo;
    
    this.chartData = {
      labels: volume.map(v => v.periodo),
      datasets: [
        {
          label: 'Total',
          data: volume.map(v => v.total),
          fill: false,
          borderColor: '#3B82F6',
          tension: .4
        },
        {
          label: 'Sucesso',
          data: volume.map(v => v.sucesso),
          fill: false,
          borderColor: '#10B981',
          tension: .4
        },
        {
          label: 'Erro',
          data: volume.map(v => v.erro),
          fill: false,
          borderColor: '#EF4444',
          tension: .4
        }
      ]
    };

    this.chartOptions = {
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        },
        y: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        }
      }
    };

    const status = this.dashboardData.graficos.statusDistribuicao;
    this.pieData = {
      labels: ['Pendente', 'Processando', 'Concluído', 'Erro'],
      datasets: [
        {
          data: [status.PENDENTE, status.PROCESSANDO, status.CONCLUIDO, status.ERRO],
          backgroundColor: ['#F59E0B', '#3B82F6', '#10B981', '#EF4444'],
          hoverBackgroundColor: ['#fbbf24', '#60a5fa', '#34d399', '#f87171']
        }
      ]
    };

    this.pieOptions = {
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#495057'
          }
        }
      }
    };
  }
}
